export default __webpack_public_path__ + "assets/images/store-house_2u3su.jpg";